// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ══════════════════════════════════════
   ComboModal — right-side drawer
   ══════════════════════════════════════ */

.cmo-container {
  display: flex;
  flex-direction: row;
  width: 100%;
  height: 100%;
  overflow: hidden;
  background: #f7f8fa;
}

/* ── Left panel ── */
.cmo-left {
  width: 300px;
  min-width: 300px;
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  background: #fff;
  overflow-y: auto;
  height: 100%;
  border-right: 1px solid #eef0f3;
  scrollbar-width: thin;
  scrollbar-color: #d1d5db transparent;
}

.cmo-left::-webkit-scrollbar { width: 3px; }
.cmo-left::-webkit-scrollbar-thumb { background: #d1d5db; border-radius: 4px; }

/* Image wrap */
.cmo-img-wrap {
  position: relative;
  width: 100%;
  height: 300px;
  overflow: hidden;
  flex-shrink: 0;
}

.cmo-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

/* Top badges */
.cmo-top-badges {
  position: absolute;
  top: 12px;
  left: 12px;
  display: flex;
  align-items: center;
  gap: 6px;
  z-index: 2;
}

.cmo-badge-combo {
  font-size: 11px;
  font-weight: 700;
  padding: 4px 12px;
  border-radius: 20px;
  background: #7c3aed;
  color: #fff;
  backdrop-filter: blur(4px);
}

.cmo-badge-includes {
  font-size: 11px;
  font-weight: 600;
  padding: 4px 12px;
  border-radius: 20px;
  background: rgba(255, 255, 255, 0.88);
  color: #374151;
  backdrop-filter: blur(4px);
}

/* Close button — inside image top-right */
.cmo-close-btn {
  position: absolute;
  top: 12px;
  right: 12px;
  z-index: 3;
  width: 30px;
  height: 30px;
  border-radius: 50%;
  border: none;
  background: rgba(255, 255, 255, 0.92);
  color: #374151;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background 0.15s;
  box-shadow: 0 1px 4px rgba(0,0,0,0.15);
}

.cmo-close-btn:hover { background: #fff; }

/* Bottom meta overlay */
.cmo-img-meta {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 32px 14px 12px;
  background: linear-gradient(to top, rgba(0,0,0,0.75) 0%, transparent 100%);
}

.cmo-img-meta-name-row {
  display: flex;
  align-items: center;
  gap: 6px;
  margin-bottom: 6px;
  flex-wrap: wrap;
}

.cmo-food-dot {
  width: 16px;
  height: 16px;
  flex-shrink: 0;
}

.cmo-img-product-name {
  font-size: 1rem;
  font-weight: 700;
  color: #fff;
  line-height: 1.2;
}

.cmo-img-shortcode {
  font-size: 10px;
  font-weight: 600;
  background: rgba(255,255,255,0.18);
  color: #e5e7eb;
  padding: 2px 7px;
  border-radius: 4px;
  white-space: nowrap;
  backdrop-filter: blur(2px);
}

.cmo-img-meta-price-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
}

.cmo-ordered-times {
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: 11px;
  font-weight: 500;
  color: rgba(255,255,255,0.85);
}

.cmo-img-price {
  font-size: 1.35rem;
  font-weight: 800;
  color: #fff;
}

/* ── Pricing card ── */
.cmo-pricing-card {
  margin: 12px;
  background: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 14px;
  padding: 14px;
  flex: 1;
}

.cmo-pricing-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
}

.cmo-pricing-title {
  font-size: 14px;
  font-weight: 700;
  color: #111827;
}

.cmo-pricing-hint {
  font-size: 12px;
  color: #64748b;
  font-weight: 500;
  background-color: #f1f5f9;
  padding: 4px 12px;
  border-radius: 9999px;
}

.cmo-pricing-option {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  padding: 11px 14px;
  border: 1.5px solid #e5e7eb;
  border-radius: 24px;
  margin-bottom: 8px;
  cursor: pointer;
  transition: border-color 0.15s, background 0.15s;
  background: #fff;
}

.cmo-pricing-option:hover { border-color: #93c5fd; background: #f8faff; }
.cmo-pricing-option--active { border-color: #0860e6; background: #eff6ff; }
.cmo-pricing-option--active .cmo-option-label { color: #0860e6; font-weight: 700; }

.cmo-pricing-option--disabled {
  opacity: 0.6;
  background: #fafafa;
  border-color: #e5e7eb;
  cursor: not-allowed;
}
.cmo-pricing-option--disabled:hover {
  border-color: #e5e7eb;
  background: #fafafa;
}
.cmo-pricing-option--disabled .cmo-option-label {
  color: #9ca3af;
}

.cmo-option-label {
  font-size: 13px;
  font-weight: 600;
  color: #111827;
  flex: 1;
}

.cmo-radio {
  accent-color: #0860e6;
  flex-shrink: 0;
  width: 17px;
  height: 17px;
  cursor: pointer;
}

.cmo-discount-row {
  display: flex;
  align-items: center;
  gap: 6px;
  margin: -2px 0 8px;
  padding: 8px 12px;
  background: #f0f6ff;
  border-radius: 8px;
  border: 1px solid #bfdbfe;
}

.cmo-discount-type-btn {
  padding: 4px 10px;
  border: 1.5px solid #d1d5db;
  border-radius: 6px;
  background: #fff;
  font-size: 13px;
  font-weight: 600;
  color: #374151;
  cursor: pointer;
  transition: all 0.15s;
}

.cmo-discount-type-btn.active {
  border-color: #0860e6;
  background: #eff6ff;
  color: #0860e6;
}

.cmo-discount-input {
  flex: 1;
  border: 1.5px solid #d1d5db;
  border-radius: 6px;
  padding: 4px 8px;
  font-size: 13px;
  outline: none;
  font-family: inherit;
}

.cmo-discount-input:focus { border-color: #0860e6; }

/* ── Right panel ── */
.cmo-right {
  flex: 1;
  display: flex;
  flex-direction: column;
  background: #f7f8fa;
  overflow: hidden;
  height: 100%;
  position: relative;
}

/* Close button — top-right of the right panel */
.cmo-drawer-close-btn {
  position: absolute;
  top: 8px;
  right:-3px;
  z-index: 10;
  width: 24px;
  height: 24px;
  border: none;
  background: transparent;
  color: #64748b;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: color 0.15s;
  line-height: 1;
  padding: 0;
}

.cmo-drawer-close-btn:hover {
  color: #0f172a;
}


.cmo-right-body {
  flex: 1;
  overflow-y: auto;
  padding: 16px 16px 8px;
  scrollbar-width: thin;
  scrollbar-color: #d1d5db transparent;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.cmo-right-body::-webkit-scrollbar { width: 4px; }
.cmo-right-body::-webkit-scrollbar-thumb { background: #d1d5db; border-radius: 4px; }

/* ── Section cards ── */
.cmo-section-card {
  background: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 14px;
  padding: 16px;
  margin-top: 10px;
}

.cmo-section-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 10px;
  margin-bottom: 14px;
}

.cmo-right-title {
  font-size: 16px;
  font-weight: 700;
  color: #111827;
  margin: 0 0 3px;
}

.cmo-right-subtitle {
  font-size: 12px;
  color: #6b7280;
  margin: 0;
}

.cmo-items-badge {
  font-size: 11px;
  font-weight: 700;
  color: #7c3aed;
  background: #ede9fe;
  border: 1px solid #c4b5fd;
  border-radius: 12px;
  padding: 3px 10px;
  white-space: nowrap;
  flex-shrink: 0;
}

/* Combo items — 3-column grid */
.cmo-items-row {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 10px;
}

.cmo-item-card {
  background: #fff;
  border: 1px solid #f0f2f5;
  border-radius: 10px;
  overflow: hidden;
}

.cmo-item-img-wrap {
  height: 90px;
  overflow: hidden;
}

.cmo-item-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.cmo-item-name {
  font-size: 12px;
  font-weight: 600;
  color: #374151;
  padding: 7px 8px;
  margin: 0;
  line-height: 1.3;
  display: flex;
  align-items: center;
  gap: 5px;
}

.cmo-item-num {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 18px;
  height: 18px;
  border-radius: 50%;
  background: #e0e7ff;
  color: #4338ca;
  font-size: 10px;
  font-weight: 700;
  flex-shrink: 0;
}

/* Notes card */
.cmo-notes-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
}

.cmo-notes-title {
  font-size: 14px;
  font-weight: 700;
  color: #111827;
}

.cmo-notes-optional {
  font-size: 11px;
  font-weight: 600;
  color: #9ca3af;
  background: #f3f4f6;
  padding: 2px 8px;
  border-radius: 10px;
}

.cmo-notes-input {
  width: 100%;
  border: 1.5px solid #e5e7eb;
  border-radius: 10px;
  padding: 10px 12px;
  font-size: 13px;
  color: #374151;
  resize: none;
  outline: none;
  box-sizing: border-box;
  font-family: inherit;
  background: #fff;
  transition: border-color 0.15s;
}

.cmo-notes-input:focus { border-color: #0860e6; }
.cmo-notes-input::placeholder { color: #d1d5db; }

/* ── Footer ── */
.cmo-footer {
  padding: 12px 20px 14px;
  border-top: 1px solid #e5e7eb;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  flex-shrink: 0;
  background: #fff;
}

.cmo-total { display: flex; flex-direction: column; gap: 2px; }

.cmo-total-label {
  font-size: 13px;
  color: #64748b;
  font-weight: 600;
}

.cmo-total-price {
  font-size: 24px;
  font-weight: 800;
  color: #0f172a;
  display: flex;
  align-items: center;
  gap: 6px;
  line-height: 1.1;
}

.cmo-total-strike {
  font-size: 14px;
  font-weight: 600;
  color: #9ca3af;
  text-decoration: line-through;
}

.cmo-total-free { color: #7c3aed; font-size: 24px; font-weight: 800; }

.cmo-footer-actions { display: flex; align-items: center; gap: 12px; flex-shrink: 0; }

.cmo-qty-control {
  display: flex;
  align-items: center;
  border: 1.5px solid #e2e8f0;
  border-radius: 24px;
  overflow: hidden;
  height: 40px;
  padding: 0 4px;
}

.cmo-qty-btn {
  width: 32px;
  height: 32px;
  border: none;
  background: transparent;
  font-size: 20px;
  font-weight: 400;
  color: #64748b;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: color 0.15s, background 0.15s;
  border-radius: 50%;
}

.cmo-qty-btn:hover:not(:disabled) { background: #f1f5f9; color: #0f172a; }
.cmo-qty-btn:disabled { opacity: 0.4; cursor: not-allowed; }

.cmo-qty-value {
  min-width: 32px;
  text-align: center;
  font-size: 16px;
  font-weight: 700;
  color: #0f172a;
}

.cmo-add-btn {
  height: 40px;
  padding: 0 20px;
  background: #007bff;
  color: #fff;
  border: none;
  border-radius: 24px;
  font-size: 15px;
  font-weight: 700;
  cursor: pointer;
  font-family: inherit;
  transition: background 0.15s;
  white-space: nowrap;
  display: flex;
  align-items: center;
  gap: 6px;
}

.cmo-add-btn:hover { background: #0069d9; }

/* ═══ DARK THEME — ComboModal ═══ */
.dark .cmo-container { background: #0f172a; }

.dark .cmo-left {
  background: #1e293b;
  border-right-color: #334155;
  scrollbar-color: #334155 transparent;
}

.dark .cmo-pricing-card {
  background: #1e293b;
  border-color: #334155;
}
.dark .cmo-pricing-title { color: #f1f5f9; }
.dark .cmo-pricing-hint  { background-color: #0f172a; color: #94a3b8; }

.dark .cmo-pricing-option {
  background: #0f172a;
  border-color: #334155;
}
.dark .cmo-pricing-option:hover { border-color: #3b82f6; background: #1e293b; }
.dark .cmo-pricing-option--active { border-color: #0860e6; background: rgba(8,96,230,0.1); }
.dark .cmo-pricing-option--disabled { background: #1e293b; }
.dark .cmo-option-label { color: #e2e8f0; }

.dark .cmo-discount-row { background: #172554; border-color: #1d4ed8; }
.dark .cmo-discount-type-btn {
  background: #1e293b;
  border-color: #334155;
  color: #e2e8f0;
}
.dark .cmo-discount-type-btn.active {
  border-color: #0860e6;
  background: rgba(8,96,230,0.15);
  color: #60a5fa;
}
.dark .cmo-discount-input {
  background: #0f172a;
  border-color: #334155;
  color: #e2e8f0;
}

.dark .cmo-right { background: #0f172a; }
.dark .cmo-right-body { scrollbar-color: #334155 transparent; }

.dark .cmo-section-card {
  background: #1e293b;
  border-color: #334155;
}
.dark .cmo-right-title  { color: #f1f5f9; }
.dark .cmo-right-subtitle { color: #64748b; }
.dark .cmo-notes-title { color: #f1f5f9; }
.dark .cmo-notes-optional { background: #0f172a; color: #64748b; }
.dark .cmo-notes-input {
  background: #0f172a;
  border-color: #334155;
  color: #e2e8f0;
}
.dark .cmo-notes-input:focus { border-color: #0860e6; }
.dark .cmo-notes-input::placeholder { color: #475569; }

.dark .cmo-item-card {
  background: #1e293b;
  border-color: #334155;
}
.dark .cmo-item-name { color: #cbd5e1; }
.dark .cmo-item-num { background: #1e3a8a; color: #93c5fd; }

.dark .cmo-footer {
  background: #1e293b;
  border-top-color: #334155;
}
.dark .cmo-total-label  { color: #94a3b8; }
.dark .cmo-total-price  { color: #f1f5f9; }
.dark .cmo-total-strike { color: #64748b; }

.dark .cmo-qty-control { border-color: #334155; }
.dark .cmo-qty-btn { color: #94a3b8; }
.dark .cmo-qty-btn:hover:not(:disabled) { background: #334155; color: #f1f5f9; }
.dark .cmo-qty-value { color: #f1f5f9; }
`, "",{"version":3,"sources":["webpack://./client/src/layouts/ecommerce/product/all-products/components/ComboModal/ComboModal.css"],"names":[],"mappings":"AAAA;;2CAE2C;;AAE3C;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA,qBAAqB;AACrB;EACE,YAAY;EACZ,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,gBAAgB;EAChB,YAAY;EACZ,+BAA+B;EAC/B,qBAAqB;EACrB,oCAAoC;AACtC;;AAEA,+BAA+B,UAAU,EAAE;AAC3C,qCAAqC,mBAAmB,EAAE,kBAAkB,EAAE;;AAE9E,eAAe;AACf;EACE,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,cAAc;AAChB;;AAEA,eAAe;AACf;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,mBAAmB;EACnB,WAAW;EACX,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,qCAAqC;EACrC,cAAc;EACd,0BAA0B;AAC5B;;AAEA,0CAA0C;AAC1C;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,UAAU;EACV,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,qCAAqC;EACrC,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,4BAA4B;EAC5B,sCAAsC;AACxC;;AAEA,uBAAuB,gBAAgB,EAAE;;AAEzC,wBAAwB;AACxB;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,QAAQ;EACR,uBAAuB;EACvB,0EAA0E;AAC5E;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kCAAkC;EAClC,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;AACb;;AAEA,uBAAuB;AACvB;EACE,YAAY;EACZ,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,OAAO;AACT;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,yBAAyB;EACzB,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;EAClB,2BAA2B;EAC3B,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,gDAAgD;EAChD,gBAAgB;AAClB;;AAEA,4BAA4B,qBAAqB,EAAE,mBAAmB,EAAE;AACxE,8BAA8B,qBAAqB,EAAE,mBAAmB,EAAE;AAC1E,gDAAgD,cAAc,EAAE,gBAAgB,EAAE;;AAElF;EACE,YAAY;EACZ,mBAAmB;EACnB,qBAAqB;EACrB,mBAAmB;AACrB;AACA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;AACA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,OAAO;AACT;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,2BAA2B;EAC3B,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,OAAO;EACP,2BAA2B;EAC3B,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,oBAAoB;AACtB;;AAEA,4BAA4B,qBAAqB,EAAE;;AAEnD,sBAAsB;AACtB;EACE,OAAO;EACP,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;AACpB;;AAEA,gDAAgD;AAChD;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,WAAW;EACX,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,uBAAuB;EACvB,cAAc;EACd,UAAU;AACZ;;AAEA;EACE,cAAc;AAChB;;;AAGA;EACE,OAAO;EACP,gBAAgB;EAChB,sBAAsB;EACtB,qBAAqB;EACrB,oCAAoC;EACpC,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA,qCAAqC,UAAU,EAAE;AACjD,2CAA2C,mBAAmB,EAAE,kBAAkB,EAAE;;AAEpF,wBAAwB;AACxB;EACE,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,SAAS;AACX;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;EACnB,cAAc;AAChB;;AAEA,gCAAgC;AAChC;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,SAAS;EACT,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA,eAAe;AACf;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,2BAA2B;EAC3B,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,oBAAoB;EACpB,gBAAgB;EAChB,8BAA8B;AAChC;;AAEA,yBAAyB,qBAAqB,EAAE;AAChD,gCAAgC,cAAc,EAAE;;AAEhD,iBAAiB;AACjB;EACE,uBAAuB;EACvB,6BAA6B;EAC7B,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,cAAc;EACd,gBAAgB;AAClB;;AAEA,aAAa,aAAa,EAAE,sBAAsB,EAAE,QAAQ,EAAE;;AAE9D;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,6BAA6B;AAC/B;;AAEA,kBAAkB,cAAc,EAAE,eAAe,EAAE,gBAAgB,EAAE;;AAErE,sBAAsB,aAAa,EAAE,mBAAmB,EAAE,SAAS,EAAE,cAAc,EAAE;;AAErF;EACE,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,mBAAmB;EACnB,gBAAgB;EAChB,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yCAAyC;EACzC,kBAAkB;AACpB;;AAEA,oCAAoC,mBAAmB,EAAE,cAAc,EAAE;AACzE,wBAAwB,YAAY,EAAE,mBAAmB,EAAE;;AAE3D;EACE,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,4BAA4B;EAC5B,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA,qBAAqB,mBAAmB,EAAE;;AAE1C,oCAAoC;AACpC,uBAAuB,mBAAmB,EAAE;;AAE5C;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,oCAAoC;AACtC;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;AACA,2BAA2B,cAAc,EAAE;AAC3C,2BAA2B,yBAAyB,EAAE,cAAc,EAAE;;AAEtE;EACE,mBAAmB;EACnB,qBAAqB;AACvB;AACA,kCAAkC,qBAAqB,EAAE,mBAAmB,EAAE;AAC9E,oCAAoC,qBAAqB,EAAE,8BAA8B,EAAE;AAC3F,sCAAsC,mBAAmB,EAAE;AAC3D,0BAA0B,cAAc,EAAE;;AAE1C,0BAA0B,mBAAmB,EAAE,qBAAqB,EAAE;AACtE;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;AACA;EACE,qBAAqB;EACrB,+BAA+B;EAC/B,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA,mBAAmB,mBAAmB,EAAE;AACxC,wBAAwB,oCAAoC,EAAE;;AAE9D;EACE,mBAAmB;EACnB,qBAAqB;AACvB;AACA,0BAA0B,cAAc,EAAE;AAC1C,4BAA4B,cAAc,EAAE;AAC5C,yBAAyB,cAAc,EAAE;AACzC,4BAA4B,mBAAmB,EAAE,cAAc,EAAE;AACjE;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;AACA,+BAA+B,qBAAqB,EAAE;AACtD,sCAAsC,cAAc,EAAE;;AAEtD;EACE,mBAAmB;EACnB,qBAAqB;AACvB;AACA,uBAAuB,cAAc,EAAE;AACvC,sBAAsB,mBAAmB,EAAE,cAAc,EAAE;;AAE3D;EACE,mBAAmB;EACnB,yBAAyB;AAC3B;AACA,0BAA0B,cAAc,EAAE;AAC1C,0BAA0B,cAAc,EAAE;AAC1C,0BAA0B,cAAc,EAAE;;AAE1C,yBAAyB,qBAAqB,EAAE;AAChD,qBAAqB,cAAc,EAAE;AACrC,0CAA0C,mBAAmB,EAAE,cAAc,EAAE;AAC/E,uBAAuB,cAAc,EAAE","sourcesContent":["/* ══════════════════════════════════════\n   ComboModal — right-side drawer\n   ══════════════════════════════════════ */\n\n.cmo-container {\n  display: flex;\n  flex-direction: row;\n  width: 100%;\n  height: 100%;\n  overflow: hidden;\n  background: #f7f8fa;\n}\n\n/* ── Left panel ── */\n.cmo-left {\n  width: 300px;\n  min-width: 300px;\n  flex-shrink: 0;\n  display: flex;\n  flex-direction: column;\n  background: #fff;\n  overflow-y: auto;\n  height: 100%;\n  border-right: 1px solid #eef0f3;\n  scrollbar-width: thin;\n  scrollbar-color: #d1d5db transparent;\n}\n\n.cmo-left::-webkit-scrollbar { width: 3px; }\n.cmo-left::-webkit-scrollbar-thumb { background: #d1d5db; border-radius: 4px; }\n\n/* Image wrap */\n.cmo-img-wrap {\n  position: relative;\n  width: 100%;\n  height: 300px;\n  overflow: hidden;\n  flex-shrink: 0;\n}\n\n.cmo-img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  display: block;\n}\n\n/* Top badges */\n.cmo-top-badges {\n  position: absolute;\n  top: 12px;\n  left: 12px;\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  z-index: 2;\n}\n\n.cmo-badge-combo {\n  font-size: 11px;\n  font-weight: 700;\n  padding: 4px 12px;\n  border-radius: 20px;\n  background: #7c3aed;\n  color: #fff;\n  backdrop-filter: blur(4px);\n}\n\n.cmo-badge-includes {\n  font-size: 11px;\n  font-weight: 600;\n  padding: 4px 12px;\n  border-radius: 20px;\n  background: rgba(255, 255, 255, 0.88);\n  color: #374151;\n  backdrop-filter: blur(4px);\n}\n\n/* Close button — inside image top-right */\n.cmo-close-btn {\n  position: absolute;\n  top: 12px;\n  right: 12px;\n  z-index: 3;\n  width: 30px;\n  height: 30px;\n  border-radius: 50%;\n  border: none;\n  background: rgba(255, 255, 255, 0.92);\n  color: #374151;\n  font-size: 13px;\n  font-weight: 600;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: background 0.15s;\n  box-shadow: 0 1px 4px rgba(0,0,0,0.15);\n}\n\n.cmo-close-btn:hover { background: #fff; }\n\n/* Bottom meta overlay */\n.cmo-img-meta {\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  padding: 32px 14px 12px;\n  background: linear-gradient(to top, rgba(0,0,0,0.75) 0%, transparent 100%);\n}\n\n.cmo-img-meta-name-row {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  margin-bottom: 6px;\n  flex-wrap: wrap;\n}\n\n.cmo-food-dot {\n  width: 16px;\n  height: 16px;\n  flex-shrink: 0;\n}\n\n.cmo-img-product-name {\n  font-size: 1rem;\n  font-weight: 700;\n  color: #fff;\n  line-height: 1.2;\n}\n\n.cmo-img-shortcode {\n  font-size: 10px;\n  font-weight: 600;\n  background: rgba(255,255,255,0.18);\n  color: #e5e7eb;\n  padding: 2px 7px;\n  border-radius: 4px;\n  white-space: nowrap;\n  backdrop-filter: blur(2px);\n}\n\n.cmo-img-meta-price-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n}\n\n.cmo-ordered-times {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  font-size: 11px;\n  font-weight: 500;\n  color: rgba(255,255,255,0.85);\n}\n\n.cmo-img-price {\n  font-size: 1.35rem;\n  font-weight: 800;\n  color: #fff;\n}\n\n/* ── Pricing card ── */\n.cmo-pricing-card {\n  margin: 12px;\n  background: #fff;\n  border: 1px solid #e5e7eb;\n  border-radius: 14px;\n  padding: 14px;\n  flex: 1;\n}\n\n.cmo-pricing-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 10px;\n}\n\n.cmo-pricing-title {\n  font-size: 14px;\n  font-weight: 700;\n  color: #111827;\n}\n\n.cmo-pricing-hint {\n  font-size: 12px;\n  color: #64748b;\n  font-weight: 500;\n  background-color: #f1f5f9;\n  padding: 4px 12px;\n  border-radius: 9999px;\n}\n\n.cmo-pricing-option {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 10px;\n  padding: 11px 14px;\n  border: 1.5px solid #e5e7eb;\n  border-radius: 24px;\n  margin-bottom: 8px;\n  cursor: pointer;\n  transition: border-color 0.15s, background 0.15s;\n  background: #fff;\n}\n\n.cmo-pricing-option:hover { border-color: #93c5fd; background: #f8faff; }\n.cmo-pricing-option--active { border-color: #0860e6; background: #eff6ff; }\n.cmo-pricing-option--active .cmo-option-label { color: #0860e6; font-weight: 700; }\n\n.cmo-pricing-option--disabled {\n  opacity: 0.6;\n  background: #fafafa;\n  border-color: #e5e7eb;\n  cursor: not-allowed;\n}\n.cmo-pricing-option--disabled:hover {\n  border-color: #e5e7eb;\n  background: #fafafa;\n}\n.cmo-pricing-option--disabled .cmo-option-label {\n  color: #9ca3af;\n}\n\n.cmo-option-label {\n  font-size: 13px;\n  font-weight: 600;\n  color: #111827;\n  flex: 1;\n}\n\n.cmo-radio {\n  accent-color: #0860e6;\n  flex-shrink: 0;\n  width: 17px;\n  height: 17px;\n  cursor: pointer;\n}\n\n.cmo-discount-row {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  margin: -2px 0 8px;\n  padding: 8px 12px;\n  background: #f0f6ff;\n  border-radius: 8px;\n  border: 1px solid #bfdbfe;\n}\n\n.cmo-discount-type-btn {\n  padding: 4px 10px;\n  border: 1.5px solid #d1d5db;\n  border-radius: 6px;\n  background: #fff;\n  font-size: 13px;\n  font-weight: 600;\n  color: #374151;\n  cursor: pointer;\n  transition: all 0.15s;\n}\n\n.cmo-discount-type-btn.active {\n  border-color: #0860e6;\n  background: #eff6ff;\n  color: #0860e6;\n}\n\n.cmo-discount-input {\n  flex: 1;\n  border: 1.5px solid #d1d5db;\n  border-radius: 6px;\n  padding: 4px 8px;\n  font-size: 13px;\n  outline: none;\n  font-family: inherit;\n}\n\n.cmo-discount-input:focus { border-color: #0860e6; }\n\n/* ── Right panel ── */\n.cmo-right {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  background: #f7f8fa;\n  overflow: hidden;\n  height: 100%;\n  position: relative;\n}\n\n/* Close button — top-right of the right panel */\n.cmo-drawer-close-btn {\n  position: absolute;\n  top: 8px;\n  right:-3px;\n  z-index: 10;\n  width: 24px;\n  height: 24px;\n  border: none;\n  background: transparent;\n  color: #64748b;\n  font-size: 15px;\n  font-weight: 600;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: color 0.15s;\n  line-height: 1;\n  padding: 0;\n}\n\n.cmo-drawer-close-btn:hover {\n  color: #0f172a;\n}\n\n\n.cmo-right-body {\n  flex: 1;\n  overflow-y: auto;\n  padding: 16px 16px 8px;\n  scrollbar-width: thin;\n  scrollbar-color: #d1d5db transparent;\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.cmo-right-body::-webkit-scrollbar { width: 4px; }\n.cmo-right-body::-webkit-scrollbar-thumb { background: #d1d5db; border-radius: 4px; }\n\n/* ── Section cards ── */\n.cmo-section-card {\n  background: #fff;\n  border: 1px solid #e5e7eb;\n  border-radius: 14px;\n  padding: 16px;\n  margin-top: 10px;\n}\n\n.cmo-section-header {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 10px;\n  margin-bottom: 14px;\n}\n\n.cmo-right-title {\n  font-size: 16px;\n  font-weight: 700;\n  color: #111827;\n  margin: 0 0 3px;\n}\n\n.cmo-right-subtitle {\n  font-size: 12px;\n  color: #6b7280;\n  margin: 0;\n}\n\n.cmo-items-badge {\n  font-size: 11px;\n  font-weight: 700;\n  color: #7c3aed;\n  background: #ede9fe;\n  border: 1px solid #c4b5fd;\n  border-radius: 12px;\n  padding: 3px 10px;\n  white-space: nowrap;\n  flex-shrink: 0;\n}\n\n/* Combo items — 3-column grid */\n.cmo-items-row {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 10px;\n}\n\n.cmo-item-card {\n  background: #fff;\n  border: 1px solid #f0f2f5;\n  border-radius: 10px;\n  overflow: hidden;\n}\n\n.cmo-item-img-wrap {\n  height: 90px;\n  overflow: hidden;\n}\n\n.cmo-item-img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  display: block;\n}\n\n.cmo-item-name {\n  font-size: 12px;\n  font-weight: 600;\n  color: #374151;\n  padding: 7px 8px;\n  margin: 0;\n  line-height: 1.3;\n  display: flex;\n  align-items: center;\n  gap: 5px;\n}\n\n.cmo-item-num {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 18px;\n  height: 18px;\n  border-radius: 50%;\n  background: #e0e7ff;\n  color: #4338ca;\n  font-size: 10px;\n  font-weight: 700;\n  flex-shrink: 0;\n}\n\n/* Notes card */\n.cmo-notes-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 10px;\n}\n\n.cmo-notes-title {\n  font-size: 14px;\n  font-weight: 700;\n  color: #111827;\n}\n\n.cmo-notes-optional {\n  font-size: 11px;\n  font-weight: 600;\n  color: #9ca3af;\n  background: #f3f4f6;\n  padding: 2px 8px;\n  border-radius: 10px;\n}\n\n.cmo-notes-input {\n  width: 100%;\n  border: 1.5px solid #e5e7eb;\n  border-radius: 10px;\n  padding: 10px 12px;\n  font-size: 13px;\n  color: #374151;\n  resize: none;\n  outline: none;\n  box-sizing: border-box;\n  font-family: inherit;\n  background: #fff;\n  transition: border-color 0.15s;\n}\n\n.cmo-notes-input:focus { border-color: #0860e6; }\n.cmo-notes-input::placeholder { color: #d1d5db; }\n\n/* ── Footer ── */\n.cmo-footer {\n  padding: 12px 20px 14px;\n  border-top: 1px solid #e5e7eb;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  flex-shrink: 0;\n  background: #fff;\n}\n\n.cmo-total { display: flex; flex-direction: column; gap: 2px; }\n\n.cmo-total-label {\n  font-size: 13px;\n  color: #64748b;\n  font-weight: 600;\n}\n\n.cmo-total-price {\n  font-size: 24px;\n  font-weight: 800;\n  color: #0f172a;\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  line-height: 1.1;\n}\n\n.cmo-total-strike {\n  font-size: 14px;\n  font-weight: 600;\n  color: #9ca3af;\n  text-decoration: line-through;\n}\n\n.cmo-total-free { color: #7c3aed; font-size: 24px; font-weight: 800; }\n\n.cmo-footer-actions { display: flex; align-items: center; gap: 12px; flex-shrink: 0; }\n\n.cmo-qty-control {\n  display: flex;\n  align-items: center;\n  border: 1.5px solid #e2e8f0;\n  border-radius: 24px;\n  overflow: hidden;\n  height: 40px;\n  padding: 0 4px;\n}\n\n.cmo-qty-btn {\n  width: 32px;\n  height: 32px;\n  border: none;\n  background: transparent;\n  font-size: 20px;\n  font-weight: 400;\n  color: #64748b;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: color 0.15s, background 0.15s;\n  border-radius: 50%;\n}\n\n.cmo-qty-btn:hover:not(:disabled) { background: #f1f5f9; color: #0f172a; }\n.cmo-qty-btn:disabled { opacity: 0.4; cursor: not-allowed; }\n\n.cmo-qty-value {\n  min-width: 32px;\n  text-align: center;\n  font-size: 16px;\n  font-weight: 700;\n  color: #0f172a;\n}\n\n.cmo-add-btn {\n  height: 40px;\n  padding: 0 20px;\n  background: #007bff;\n  color: #fff;\n  border: none;\n  border-radius: 24px;\n  font-size: 15px;\n  font-weight: 700;\n  cursor: pointer;\n  font-family: inherit;\n  transition: background 0.15s;\n  white-space: nowrap;\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.cmo-add-btn:hover { background: #0069d9; }\n\n/* ═══ DARK THEME — ComboModal ═══ */\n.dark .cmo-container { background: #0f172a; }\n\n.dark .cmo-left {\n  background: #1e293b;\n  border-right-color: #334155;\n  scrollbar-color: #334155 transparent;\n}\n\n.dark .cmo-pricing-card {\n  background: #1e293b;\n  border-color: #334155;\n}\n.dark .cmo-pricing-title { color: #f1f5f9; }\n.dark .cmo-pricing-hint  { background-color: #0f172a; color: #94a3b8; }\n\n.dark .cmo-pricing-option {\n  background: #0f172a;\n  border-color: #334155;\n}\n.dark .cmo-pricing-option:hover { border-color: #3b82f6; background: #1e293b; }\n.dark .cmo-pricing-option--active { border-color: #0860e6; background: rgba(8,96,230,0.1); }\n.dark .cmo-pricing-option--disabled { background: #1e293b; }\n.dark .cmo-option-label { color: #e2e8f0; }\n\n.dark .cmo-discount-row { background: #172554; border-color: #1d4ed8; }\n.dark .cmo-discount-type-btn {\n  background: #1e293b;\n  border-color: #334155;\n  color: #e2e8f0;\n}\n.dark .cmo-discount-type-btn.active {\n  border-color: #0860e6;\n  background: rgba(8,96,230,0.15);\n  color: #60a5fa;\n}\n.dark .cmo-discount-input {\n  background: #0f172a;\n  border-color: #334155;\n  color: #e2e8f0;\n}\n\n.dark .cmo-right { background: #0f172a; }\n.dark .cmo-right-body { scrollbar-color: #334155 transparent; }\n\n.dark .cmo-section-card {\n  background: #1e293b;\n  border-color: #334155;\n}\n.dark .cmo-right-title  { color: #f1f5f9; }\n.dark .cmo-right-subtitle { color: #64748b; }\n.dark .cmo-notes-title { color: #f1f5f9; }\n.dark .cmo-notes-optional { background: #0f172a; color: #64748b; }\n.dark .cmo-notes-input {\n  background: #0f172a;\n  border-color: #334155;\n  color: #e2e8f0;\n}\n.dark .cmo-notes-input:focus { border-color: #0860e6; }\n.dark .cmo-notes-input::placeholder { color: #475569; }\n\n.dark .cmo-item-card {\n  background: #1e293b;\n  border-color: #334155;\n}\n.dark .cmo-item-name { color: #cbd5e1; }\n.dark .cmo-item-num { background: #1e3a8a; color: #93c5fd; }\n\n.dark .cmo-footer {\n  background: #1e293b;\n  border-top-color: #334155;\n}\n.dark .cmo-total-label  { color: #94a3b8; }\n.dark .cmo-total-price  { color: #f1f5f9; }\n.dark .cmo-total-strike { color: #64748b; }\n\n.dark .cmo-qty-control { border-color: #334155; }\n.dark .cmo-qty-btn { color: #94a3b8; }\n.dark .cmo-qty-btn:hover:not(:disabled) { background: #334155; color: #f1f5f9; }\n.dark .cmo-qty-value { color: #f1f5f9; }\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
